<template>
  <v-flex xs12 class="highlight primary--text marketSearch">
    <v-layout row>
      <v-flex :class="$route.path.includes('/search') ? 'xs8' : 'xs12'" style="display: flex;">
        <v-text-field hide-details placeholder="Search for projects" color="accent" flat solo v-model="searchInput" v-on:keyup.enter="searchProjects()"></v-text-field>
        <div class="marketSearchButton primary" @click="searchProjects()"><v-icon class="secondary--text">search</v-icon></div>
      </v-flex>
      <v-flex xs2 style="flex: none;" v-if="$route.path.includes('/search')">
        <v-menu bottom offset-y class="categoriesMenu" attach=".categoriesMenu">
          <v-btn
            slot="activator"
            flat
            :ripple="false"
            style="font-size: 18px; font-weight: 700; text-transform: capitalize">
            All Categories <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile
              v-for="(item, index) in getProjectCategories"
              :key="index"
              v-if="item !== 'trending'"
              @click="selectCategory(item)">
              <v-list-tile-title style="text-transform: capitalize" :style="getStyle(item)">
                <v-layout row style="display: flex; justify-content: space-between; align-items: center">{{ item }}
                  <v-checkbox :ripple="false" style="flex: none; padding:0" color="primary" v-model="categories[index]"></v-checkbox>
                </v-layout>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex xs2 style="flex: none" v-if="$route.path.includes('/search')">
        <v-menu bottom offset-y class="sortByMenu" attach=".sortByMenu">
          <v-btn
            slot="activator"
            flat
            :ripple="false"
            style="font-size: 18px; font-weight: 700; text-transform: capitalize">
            Sort By <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="sortResults('DESC')">
              <v-list-tile-title style="text-transform: capitalize" :style="order === 'DESC' ? 'font-weight: 800' : ''">Newest first</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="sortResults('ASC')">
              <v-list-tile-title style="text-transform: capitalize" :style="order === 'ASC' ? 'font-weight: 800' : ''">Oldest First</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<style>
  .sortByMenu .v-menu__content, .categoriesMenu .v-menu__content{
    border-radius: 10px;
  }
  .categoriesMenu .v-menu__content{
    min-width: 200px !important
  }
  .categoriesMenu .v-input--selection-controls__input{
    margin-right: 0
  }
  .sortByMenu .v-list__tile__title, .categoriesMenu .v-list__tile__title{
    font-size: 14px;
  }
  .sortByMenu a, .categoriesMenu a{
    height: 30px !important;
  }
  .marketSearch{
    height: 80px;
    padding: 0 5%;
    display: flex;
    align-items: center;
  }
  .marketSearch .v-input__slot{
    border-top-left-radius: 50px !important;
    border-bottom-left-radius: 50px !important;
  }
  .marketSearchButton{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 33px;
    border-bottom-right-radius: 50px;
    border-top-right-radius: 50px;
    cursor: pointer;
  }
  .marketSearch button:hover:before, .marketSearch button:focus:before{
    background-color: transparent !important;
  }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      searchInput: '',
      category: 'All Categories',
      order: 'DESC',
      selectedCategories: [],
      categories: []
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      getProjectCategories: 'getProjectCategories'
    })
  },
  methods: {
    searchProjects () {
      this.$router.push({path: '/search', query: {input: this.searchInput, category: this.selectedCategories, display: 'search', order: this.order}})
    },
    selectCategory (category) {
      if (this.selectedCategories.indexOf(category) !== -1) {
        this.selectedCategories.splice(this.selectedCategories.indexOf(category), 1)
        this.categories[this.getProjectCategories.indexOf(category.toLowerCase())] = false
      } else {
        this.selectedCategories.push(category.toLowerCase())
        this.categories[this.getProjectCategories.indexOf(category.toLowerCase())] = true
      }
      delete this.$route.query.category
      this.$router.push({path: '/search', query: {input: this.searchInput, category: this.selectedCategories, display: 'search', order: this.order}})
    },
    sortResults (order) {
      if (order !== this.order) {
        this.order = order
        this.$router.push({path: '/search', query: {input: this.searchInput, category: this.selectedCategories, display: 'search', order: this.order}})
      }
    },
    getStyle (item) {
      if (this.selectedCategories.indexOf(item) !== -1) {
        return 'font-weight: 800'
      }
      return ''
    }
  },
  mounted () {
    this.categories = []
    var self = this
    this.getProjectCategories.forEach(function () {
      self.categories.push(false)
    })
    if (this.$route.query.category) {
      if (Array.isArray(this.$route.query.category) && this.$route.query.category.length > 0) {
        this.selectedCategories = this.$route.query.category
      } else if (!Array.isArray(this.$route.query.category) && this.$route.query.category !== '') {
        this.selectedCategories = [this.$route.query.category]
      }
    }
    this.selectedCategories.forEach(function (cat) {
      self.categories[self.getProjectCategories.indexOf(cat.toLowerCase())] = true
    })
    this.searchInput = this.$route.query.input
  },
  watch: {
    options: function (newval, oldval) {
      this.searchInput = newval.input
      if (newval.category) {
        if (Array.isArray(newval.category) && newval.category.length > 0) {
          this.selectedCategories = newval.category
        } else if (!Array.isArray(this.$route.query.category) && newval.category !== '') {
          this.selectedCategories = [newval.category]
        }
      }
      //  else {
      //   this.selectedCategories = JSON.parse(JSON.stringify(this.getProjectCategories))
      // }
      var self = this
      this.selectedCategories.forEach(function (cat) {
        self.categories[self.getProjectCategories.indexOf(cat.toLowerCase())] = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appElements/MarketSearchBar.vue